var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import memoize from 'lodash/memoize';
import { WEBGATE_DOMAIN, webgateFetch } from './webgate-fetch';
import { useS4AMastheadContext } from '../../components/S4AMastheadProvider';
import { getSilentAuthToken } from './silentAuth';
const endpoint = `${WEBGATE_DOMAIN}/s4x-me/v0/me`;
const fetchCurrentUser = memoize((clientId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const [token] = yield getSilentAuthToken(clientId);
        if (!token)
            return null;
        const response = yield webgateFetch(endpoint, token);
        if (response.status === 401)
            return null;
        if (!response.ok)
            throw new Error(`${response.status} ${response.url}`);
        const data = (yield response.json());
        const formatted = Object.assign({ email: data.loginEmail }, data);
        return formatted;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}));
export const useCurrentUser = () => {
    const { clientId } = useS4AMastheadContext();
    const [user, setUser] = useState(undefined);
    React.useEffect(() => {
        let isMounted = true;
        if (clientId) {
            fetchCurrentUser(clientId).then(u => {
                if (isMounted)
                    setUser(u);
            });
        }
        return () => {
            isMounted = false;
        };
    }, [clientId]);
    return user;
};
//# sourceMappingURL=useCurrentUser.js.map